import { forwardRef } from 'react';
import clsx from 'clsx';
import classes from './SearchTextInput.module.css';
import type { SearchTextInputProps } from './SearchTextInput.types';
import { SearchIcon } from 'icons/outline';

export const SearchTextInput = forwardRef<HTMLInputElement, SearchTextInputProps>((props, ref) => {
  const { className, fullWidth, size = 'md', disabled = false, ...rootProps } = props;

  return (
    <div
      className={clsx(classes.root, className, {
        [classes.disabled]: disabled,
        [classes.medium]: size === 'md',
        [classes.large]: size === 'lg',
        'w-full': fullWidth,
      })}
    >
      <SearchIcon className={classes.icon} aria-hidden="true" />
      <input
        {...rootProps}
        className={clsx(classes.input, { [classes.disabled]: disabled })}
        disabled={disabled}
        type="text"
        ref={ref}
      />
    </div>
  );
});

SearchTextInput.displayName = 'SearchTextInput';
